module.exports = __webpack_public_path__ + "f84a02799204f9416cb0c8c5600e4b9d.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/pos/order_dinerCount.png
// module id = 731
// module chunks = 0